<template>
  <div class="whole-div-MHP">
    <el-container class="el-container-MHP">
      <el-header class="el-header-MHP" height="60px">
        <div style="position: absolute;left: 3%;text-align: left"><strong><span style="font-family: 楷体;">
          <a style="font-size: 15px">浙江纵海自动化设备有限公司</a><br>
          <a style="font-size: 13px;color: #0000FF" @click="openConsult">联系方式：{{this.$store.state.contactIntroduce.phoneNumber}}({{this.$store.state.contactIntroduce.personName}})</a>
        </span></strong>
        </div>
        <div style="position: absolute;right: 5%;">
        <span><i style="font-size: 30px;" class="el-icon-s-fold" @click="navigation_click"
                 @mouseenter="navigation_mouseenter" @mouseleave="navigation_mouseleave">
        </i></span>
        </div>
      </el-header>
      <el-container class="el-container2-MHP" width="100%" height="86%">
        <el-main class="el-main-MHP" @mouseover="handleClick">
          <keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
<!--          <keep-alive v-if="isKeepAlive">-->
<!--            <router-view></router-view>-->
<!--          </keep-alive>-->
<!--          <router-view v-if="!isKeepAlive"></router-view>-->
        </el-main>
        <el-aside v-if="this.$store.state.isShowNav"
                  width="130px" style="position: absolute;z-index:1;margin-top: 0;right: 0;">
          <el-menu
            router :default-active="this.$route.path"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b">
            <el-menu-item index="/MobileHomePage" @click="handleClick">
              <template slot="title">
                <i class="el-icon-position"></i>
                <span>网站首页</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/MobileAboutUs" @click="handleClick" >
              <i class="el-icon-location"></i>
              <span slot="title">关于我们</span>
            </el-menu-item>
            <el-menu-item index="/MobileProductCenter" @click="handleClick">
              <i class="el-icon-menu"></i>
              <span slot="title">产品中心</span>
            </el-menu-item>
            <el-menu-item index="/MobileNewsCenter" @click="handleClick">
              <i class="el-icon-view"></i>
              <span slot="title">新闻中心</span>
            </el-menu-item>
            <el-menu-item index="/MobileContactUs" @click="handleClick">
              <i class="el-icon-phone-outline"></i>
              <span slot="title">联系我们</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
      </el-container>
      <el-footer class="el-footer-MHP" height="60px" v-show="hideshow">
        <el-menu router :default-active="this.$route.path"
                 background-color="#545c64"
                 active-text-color="blue"
                 mode="horizontal"
                 style="width: 100%;height:100%;position: absolute;left: 0px"
        >
          <el-menu-item index="/MobileHomePage" class="el-footer-menu-MHP">
            <i class="el-icon-s-home"></i>
            <i style="font-family: 楷体;font-weight: bold;color: #FFFFFF">网站首页</i>
          </el-menu-item>
          <el-menu-item index="/MobileProductCenter" class="el-footer-menu-MHP">
            <i class="el-icon-menu"></i>
            <i style="font-weight: bold;color: #FFFFFF">产品中心</i>
          </el-menu-item>
          <el-menu-item index="/MobileNewsCenter" class="el-footer-menu-MHP">
            <i class="el-icon-s-marketing"></i>
            <i style="font-weight: bold;color: #FFFFFF">新闻中心</i>
          </el-menu-item>
          <el-menu-item index="/MobileContactUs" class="el-footer-menu-MHP">
            <i class="el-icon-mobile"></i>
            <i style="font-weight: bold;color: #FFFFFF">联系我们</i>
          </el-menu-item>
        </el-menu>
      </el-footer>
    </el-container>

    <!--      联系方式弹出框-->
    <div v-if="this.$store.state.mobileShowConsult" class="div1-mhp">
      <div class="div1-div2-mhp" @click="closeConsult">×</div>
      <div style="width:100%;position: absolute;top: 25px">
        联系人：{{this.$store.state.contactIntroduce.personName}}<br>
        手机号码：{{this.$store.state.contactIntroduce.phoneNumber}}<br></div>
      <!--      电话：{{this.$store.state.contactIntroduce.telephoneNumber}}<br><br>-->
      <div style="width:100%;position: absolute;bottom: 10px;display: flex;justify-content: center">
        <el-button v-clipboard="phoneNumber" @click="phoneConsult" type="primary" round>手机咨询</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import '../css/mobile/MHP_MobileHomePage.css'

  export default {
    name: "MobileHomePage",
    data() {
      return {
        isKeepAlive:false,
        docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
        showHeight: document.documentElement.clientHeight,   //实时屏幕高度
        hideshow: true,  //显示或者隐藏footer
        timeOpen: 0,
        timer: null,
      }
    },
    mounted() {
      this.timer = setInterval(() => {
        this.timeOpen++;
        if (this.timeOpen == 10) {
          this.$store.state.mobileShowConsult = true;
        }
      }, 600);
      // window.onresize监听页面高度的变化
      window.onresize = () => {
        return (() => {
          this.showHeight = document.documentElement.clientHeight;
          // console.log(this.showHeight);
        })()
      }
    },
    watch: {
      showHeight: function () {
        if (this.docmHeight > this.showHeight) {
          this.hidshow = false;
        } else {
          this.hidshow = true
        }
      }
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    methods: {
      //拨打手机
      phoneConsult(){
        window.location.href='tel://15381800010';
      },
      // 打开咨询弹出框
      openConsult() {
        this.$store.state.mobileShowConsult = true;
      },
      //关闭咨询弹出框
      closeConsult() {
        this.$store.state.mobileShowConsult = false;
      },
      //导航标签点击
      navigation_click() {
        if (this.isShowNav) {
          this.$store.state.isShowNav = false;
        } else {
          this.$store.state.isShowNav = true;
        }
      },
      //鼠标移到导航标签
      navigation_mouseenter(event) {
        event.target.style.backgroundColor = 'yellow';
      },
      //鼠标离开导航标签
      navigation_mouseleave(event) {
        event.target.style.backgroundColor = '';
        // this.isShowNav=false;
      },
      handleClick() {
        let that = this;
        if (that.$store.state.isShowNav == true) {
          that.$store.state.isShowNav = false;
        }else{
          that.$store.state.isShowNav=true;
        }
        // setTimeout(function () {
        //   that.$store.state.isShowNav = false;
        //   // console.log("延迟1s");
        //   // console.log(that.isShowNav);
        // }, 10)

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mobile/MobileHomePage.vue